import React, { useEffect } from 'react';
import Icon from '../shared/Icon';
import './Notification.css';

/**
 * Notification Component
 */
const Notification = ({ message, type = 'success', isVisible, onClose, duration = 5000 }) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  return (
    <div className={`notification notification-${type}`}>
      <div className="notification-content">
        <Icon name={type === 'success' ? 'check_circle' : type === 'error' ? 'error' : 'info'} className="notification-icon" size={24} />
        <span className="notification-message">{message}</span>
      </div>
      <button className="notification-close" onClick={onClose}>
        <Icon name="close" />
      </button>
    </div>
  );
};

export default Notification;

